module.exports = "https://coursera_assets.s3.amazonaws.com/images/ec45f37ce7275674c8e565421d6f5227.jpg";